import { routes } from '../constants';
import { User } from '../types/User';
import searchResultsStorageManager from './searchResultsStorageManager';
import { getDefaultSearchResultTab } from './getDefaultSearchResultTab';
import searchFiltersToQuery from './searchFiltersToQuery';

const getSearchPageUrl = (user?: User): string => {
  const storageSessionSearchFilters = searchResultsStorageManager.getSearchFilters();
  const searchTabKey = searchResultsStorageManager.getSearchTabKey();
  const tabPath = searchTabKey || getDefaultSearchResultTab(user);
  const filtersQuery = searchFiltersToQuery(storageSessionSearchFilters);
  return filtersQuery ? `/${routes.search.root}/${tabPath}?${filtersQuery}` : `/${routes.search.root}/${tabPath}`;
};

export default getSearchPageUrl;
